import Cta from './Cta';

export { type CtaProps } from './Cta';
export default Cta;
